export default "__VITE_ASSET__CyTPxgkf__"